import { Grid2 } from "@mui/material";
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import {
  Card,
  CardActions,
  CardBody,
  CardHeader,
} from "@progress/kendo-react-layout";
import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { FormTextArea } from "../../components/sys-common/FormTextArea";
import CandidateHistoryService from "../../services/CandidateHistoryService";
import { getKeyValueFromEvent } from "../../utils/getKeyValueFromEvent";
import CandidateHistory from "./CandidateHistory";

/**
 * @type {import("../../services/CandidateHistoryService").DKN_DMY_ADAY_TARIHCE[]>}
 */
const initialList = [];

const CandidateStatusForm = ({ formData }) => {
  const { t } = useTranslation();
  const [data, setData] = React.useState({
    dkN_DMY_ADAY_ID: formData.dkN_DMY_ADAY_ID,
  });
  const [list, setList] = React.useState(initialList);

  const getList = React.useCallback(() => {
    if (formData.dkN_DMY_ADAY_ID)
      CandidateHistoryService.list(formData.dkN_DMY_ADAY_ID).then((r) =>
        setList(r.data)
      );
  }, [formData.dkN_DMY_ADAY_ID]);
  React.useEffect(() => {
    getList();
  }, [getList]);
  React.useEffect(() => {
    setData({ dkN_DMY_ADAY_ID: formData.dkN_DMY_ADAY_ID });
  }, [formData.dkN_DMY_ADAY_ID]);

  const interviewStatusData = React.useMemo(
    () => t("jobApplication.interview_status_data", { returnObjects: true }),
    [t]
  );
  const handleChange = (event) => {
    const [name, value] = getKeyValueFromEvent(event);
    if (!name || name === "undefined") {
      debugger;
    }
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = () => {
    toast.promise(
      CandidateHistoryService.insert(data).then((result) => {
        setData(result.data);
        getList();
      }),
      {
        pending: "Güncelleniyor...",
        error: "Bir sorun ile karşılaşıldı",
        success: "Başvuru güncellendi.",
      }
    );
  };

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={{ xs: 12 }}>
        <Card className="w-full max-w-2xl mx-auto mt-1">
          <CardHeader>
            <h4 className="text-lg font-semibold">{t("update")}</h4>
          </CardHeader>
          <CardBody>
            <Grid2 container spacing={2}>
              <Grid2 size={12}>
                <DropDownList
                  label={t("jobApplication.candidate.status.interviewStatus")}
                  data={interviewStatusData}
                  textField="text"
                  dataItemKey="value"
                  name="adaY_GORUSME_DURUMU"
                  value={interviewStatusData.find(
                    (x) => x.value === data.adaY_GORUSME_DURUMU
                  )}
                  onChange={handleChange}
                  style={{ width: "100%" }}
                  required
                />
              </Grid2>
              <Grid2 size={12}>
                <FormTextArea
                  name="i_K_ACIKLAMA"
                  label={t("jobApplication.candidate.status.hrNotes")}
                  value={data.i_K_ACIKLAMA}
                  onChange={handleChange}
                  rows={4}
                  style={{ width: "100%" }}
                />
              </Grid2>
            </Grid2>
          </CardBody>
          <CardActions>
            <Button onClick={handleSubmit} themeColor="primary">
              {t("save")}
            </Button>
          </CardActions>
        </Card>
      </Grid2>
      <Grid2 size={{ xs: 12 }}>
        <Card>
          <CardHeader>{t("jobApplication.candidate.status.title")}</CardHeader>
          <CandidateHistory list={list} />
        </Card>
      </Grid2>
    </Grid2>
  );
};

export default CandidateStatusForm;
